import { CompanyType } from '../enums';
import { Company } from '../models';
import { useNewDocumentByFunction } from './useNewDocumentByFunction';

/**
 * Hook to allow creation of a new User
 */
export function useNewCompany(type: CompanyType) {
  const persistable = useNewDocumentByFunction('createCompany', {
    ...new Company(type),
  });

  return persistable;
}
